import { isNullOrUndefined } from "util";
var Notification = /** @class */ (function () {
    function Notification() {
    }
    /**
     * Show success notification
     *
     * @param {Object} vueInstance - Vue instance
     * @param {String} message - Message which to display on Notification
     */
    Notification.success = function (vueInstance, message) {
        vueInstance.$notify({
            group: 'global',
            type: 'success',
            //title: 'Success',
            text: message,
            duration: 5000
        });
    };
    /**
     * Show error notification
     *
     * @param {Object} vueInstance - Vue instance
     * @param {String} message - Message which to display on Notification
     */
    Notification.error = function (vueInstance, message, srMessage, msgDurationInMs) {
        if (srMessage === void 0) { srMessage = null; }
        if (msgDurationInMs === void 0) { msgDurationInMs = 5000; }
        var msg;
        if (isNullOrUndefined(srMessage))
            msg = message;
        else
            msg = message + "<span class=\"sr-only\">" + srMessage + "</span>";
        vueInstance.$notify({
            group: 'global',
            type: 'error',
            //title: 'Virhe',
            text: msg,
            duration: msgDurationInMs
        });
    };
    /**
     * Show warn notification
     *
     * @param {Object} vueInstance - Vue instance
     * @param {String} message - Message which to display on Notification
     */
    Notification.warning = function (vueInstance, message) {
        vueInstance.$notify({
            group: 'global',
            type: 'warn',
            //title: 'Something went wrong',
            text: message,
            duration: 5000
        });
    };
    return Notification;
}());
export { Notification };
